import type { WowClass } from "./wowClass";

export const ARMOR_TYPES = ["plate", "mail", "leather", "cloth"] as const;
export type ArmorType = (typeof ARMOR_TYPES)[number];

export const ARMOR_LABELS: Record<ArmorType, string> = {
  plate: "Plate",
  mail: "Mail",
  leather: "Leather",
  cloth: "Cloth",
};

export const CLASS_ARMOR: Record<WowClass, ArmorType> = {
  warrior: "plate",
  paladin: "plate",
  death_knight: "plate",
  hunter: "mail",
  shaman: "mail",
  evoker: "mail",
  rogue: "leather",
  monk: "leather",
  druid: "leather",
  demon_hunter: "leather",
  priest: "cloth",
  mage: "cloth",
  warlock: "cloth",
};
